<template>
    <table class="table table-responsive-md border border-gray">
        <thead>
            <tr class="bg-table-header">
                <th>First Name</th>
                <th>Last Name</th>
                <th>Role</th>
                <th>Relationship</th>
                <th>Primary Phone</th>
                <th class="text-center"><span v-if="isPalliative">Primary</span> Emergency Contact</th>
                <th class="text-center" v-if="isPalliative">Other Emergency Contact</th>
                <th class="text-center" v-if="!isPalliative">CAHPS Survey</th>
                <th class="text-center">Bereavement Contact</th>
                <th class="text-end">Actions</th>
            </tr>
        </thead>
        <tbody v-if="isLoading || isError || !hasData">
            <!-- LOADING -->
            <tr v-for="i of loadingCount" class="table-loading" v-if="isLoading">
                <td v-for="i of columns">
                    <span class="shimmer-loading"></span>
                </td>
            </tr>
            <!-- EMPTY -->
            <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                <td :colspan="columns">
                    <h3>No Contacts Found.</h3>
                </td>
            </tr>
            <!-- ERROR -->
            <tr class="table-error" v-if="!isLoading && isError">
                <td colspan.bind="columns">
                    <ErrorMessageHandler title="Contact list" :try-again="getContacts" />
                </td>
            </tr>
        </tbody>
        <template v-else>
            <PatientAuthorizedContactsRow
                v-for="contact of contacts"
                :contact="contact"
                :is-re-order-requested="isReOrderRequested"
                :patient-primary-address="patientPrimaryAddress"
                :columns="columns"
                :is-palliative="isPalliative"
                :patient-id="patientId"
                :total-contacts="totalContacts"
                :cahps-survey-recipient-index="cahpsSurveyRecipientIndex"
                :relationships-enum="relationshipsEnum"
                :contact-roles-enum="contactRolesEnum"
                :cahps-survey-contact-enum="cahpsSurveyContactEnum"
                :refresh-list="getContacts"
                :move-up="moveUp"
                :move-down="moveDown"
                :update-contact="updateAuthorizedContact"
                :delete-authorized-contact="deleteAuthorizedContact"
            />
        </template>
    </table>
</template>

<script lang="ts" src="./PatientAuthorizedContactsList.ts"></script>
